<template>
  <fragment>
    <button
      ref="filterButton"
      class="btn top-block__filter"
      @click="showFilter"
    >
      <i class="material-icons">filter_list</i>
      Фильтр
    </button>
    <transition name="fade">
      <form
        v-show="isFilterShown"
        ref="filterForm"
        class="top-block__filter__block"
        @submit.prevent="applyFilters"
      >
        <div class="top-block__filter__block__wrapper">
          <div
            class="top-block__filter__block__wrapper__close"
            @click="hideFilter"
          >
            <button
              type="button"
              class="close"
            >
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="row">
            <div class="col-6">
              <b class="d-flex pl-2 mb-3">Поиск по полям</b>
              <div
                v-for="(it, i) in filterKeys"
                :key="i"
                class="top-block__filter__block__deep mb-2"
              >
                <label :for="it">
                  {{ it }}
                </label>
                <div class="input-group">
                  <b-form-select
                    v-model="filters[it].modifier"
                    class="w-70-px"
                    :options="modifiers"
                    size="sm"
                  />
                  <input
                    :id="it"
                    v-model.trim="filters[it].value"
                    class="form-control form-control-sm"
                  >
                </div>
              </div>
            </div>
            <div class="col-6">
              <b class="d-flex pl-2 mb-3">Поиск по дате</b>
              <div class="top-block__filter__block__deep mb-2">
                <label>
                  Date from
                </label>
                <div class="input-group">
                  <flat-pickr
                    v-model="dateFrom"
                    class="form-control form-control-sm datepicker"
                    type="Timestamp"
                    :config="dateFromConfig"
                  />
                </div>
              </div>
              <div class="top-block__filter__block__deep mb-2">
                <label>
                  Date to
                </label>
                <div class="input-group">
                  <flat-pickr
                    v-model="dateTo"
                    class="form-control form-control-sm datepicker"
                    type="Timestamp"
                    :config="dateToConfig"
                  />
                </div>
              </div>
              <b class="d-flex pl-2 mx-2 mt-3">Поиск по данным</b>
              <template v-for="(it, i) in dataFilters">
                <div
                  :key="'dataFiltersKey' + i"
                  class="top-block__filter__block__deep mb-2"
                >
                  <label :for="'dataFilters' + i">
                    Key
                  </label>
                  <div class="input-group">
                    <input
                      :id="'dataFiltersKey' + i"
                      v-model.trim="dataFilters[i].key"
                      class="form-control form-control-sm"
                    >
                  </div>
                </div>
                <div
                  :key="'dataFiltersValue' + i"
                  class="top-block__filter__block__deep mb-2"
                >
                  <label :for="'dataFilters' + i">
                    Value
                  </label>
                  <div class="input-group">
                    <input
                      :id="'dataFiltersValue' + i"
                      v-model.trim="dataFilters[i].value"
                      class="form-control form-control-sm"
                    >
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="top-block__filter__block__deep footer">
            <button
              class="btn btn-secondary-ford-gray"
              type="button"
              @click="resetFilters"
            >
              Сбросить
            </button>
            <button
              class="btn btn-primary-ford-orange"
              type="submit"
            >
              <i class="material-icons">check</i>
              Применить
            </button>
          </div>
        </div>
      </form>
    </transition>
  </fragment>
</template>

<script>
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { mongoRegexI } from '@/utils/mongo-regex';

export default {
  name: 'FilterLogs',
  props: {
    logType: Object,
  },
  data: () => ({
    isFilterShown: false,
    modifiers: ['', 'eq', 'ne', 'in', 'nin', 'regex', 'not', 'gt', 'gte', 'lt', 'lte'],
    dataFilters: [
      {
        key: '',
        value: '',
      },
    ],
    dateFrom: null,
    dateTo: null,
    dateFromConfig: {
      locale: Russian,
      dateFormat: 'Z',
      altInput: true,
      altFormat: 'd.m.Y, H:i',
      enableTime: true,
    },
    dateToConfig: {
      locale: Russian,
      dateFormat: 'Z',
      altInput: true,
      altFormat: 'd.m.Y, H:i',
      enableTime: true,
    },
    filters: {},
  }),
  computed: {
    filterKeys() {
      return Array.from(Object.keys(this.filters));
    },
    filtersComputed() {
      const byFields = Array.from(Object.entries(this.filters)).reduce((acc, [key, value]) => {
        if (value.modifier) {
          let val = value.value;
          if (value.modifier === 'in' || value.modifier === 'nin') {
            val = val.split(/[,|]+/);
          } else if (value.modifier === 'regex' || value.modifier === 'not') {
            val = mongoRegexI(val);
          }
          acc[key] = { [`$${value.modifier}`]: val };
        } else if (value.value) {
          acc[key] = value.value;
        }
        return acc;
      }, {});

      const byData = this.dataFilters.reduce((acc, { key, value }) => {
        if (key && value) {
          acc[`data.${key}`] = value;
        }
        return acc;
      }, {});

      return {
        date: {
          $gte: this.dateFrom,
          $lte: this.dateTo,
        },
        ...byFields,
        ...byData,
      };
    },
  },
  watch: {
    logType(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setDefaultDates();
        this.createFilters();
      }
    },
  },
  created() {
    this.setDefaultDates();
    this.createFilters();
  },
  methods: {
    showFilter() {
      this.isFilterShown = true;
      setTimeout(() => {
        document.addEventListener('click', this.handleOutsideClick);
      }, 0);
    },
    hideFilter() {
      this.isFilterShown = false;
      setTimeout(() => {
        document.removeEventListener('click', this.handleOutsideClick);
      }, 0);
    },
    resetFilters() {
      Object.assign(this.$data, this.$options.data());
      this.setDefaultDates();
      this.createFilters();
      this.$emit('applyFilters', this.filtersComputed);
      this.hideFilter();
    },
    applyFilters() {
      this.$emit('applyFilters', this.filtersComputed);
      this.hideFilter();
    },
    handleOutsideClick(evt) {
            const { filterForm, filterButton } = this.$refs; //eslint-disable-line

      if (filterForm && filterForm.contains(evt.target)) {
        return;
      }

      const calendars = document.querySelectorAll('.flatpickr-calendar');
      for (let i = 0; i < calendars.length; i++) {
        if (calendars[i].contains(evt.target)) {
          return;
        }
      }

      if (filterButton && filterButton.contains(evt.target) && !this.isFilterShown) {
        return;
      }

      this.hideFilter();
    },
    setDefaultDates() {
      this.dateFrom = this.$moment().startOf('day').toISOString();
      this.dateTo = this.$moment().endOf('day').toISOString();
    },
    createFilters() {
      if (this.logType) {
        this.filters = this.logType.headers.reduce((acc, header) => {
          if (header === 'date') {
            return acc;
          }

          let name = header;
          if (header === 'user') {
            name = 'user.email';
          } else if (header === 'module') {
            name = 'module.name';
          }

          acc[name] = { value: '', modifier: '' };

          return acc;
        }, {});
      } else {
        this.filters = {};
      }
    },
  },
};
</script>

<style lang="scss" scoped>
main .top-block .top-block__filter__block {
    width: 1024px;
}
</style>
